import { ButtonBase, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { connectionChipStyles as styles } from 'src/components/Layout/components/Header/components/ConnectionChip/ConnectionChipStyles'
import { CloseRoundedIcon, RoundCheckIcon } from 'src/components/shared/ui/Icons'
import { theme } from 'src/providers/ThemeProvider'

type Props = {
  isConnectedToLexnet: boolean
  isUserAuthenticated: boolean
  onClick: () => void
}

export default function ConnectionChip({
  isConnectedToLexnet,
  isUserAuthenticated,
  onClick
}: Props): JSX.Element | null {
  const { t } = useTranslation()

  if (!isUserAuthenticated) {
    return null
  }

  return (
    <ButtonBase
      sx={styles(isConnectedToLexnet)}
      focusRipple
      onClick={onClick}
      className={'connect'}
    >
      <Box display="flex" alignItems="center">
        {isConnectedToLexnet ? (
          <CloseRoundedIcon width={16} height={16} color={theme.corporate.primaryColor} />
        ) : (
          <RoundCheckIcon width={16} height={16} color="white" />
        )}
      </Box>
      {isConnectedToLexnet
        ? t('components.connection_chips.connected')
        : t('components.connection_chips.connect')}
    </ButtonBase>
  )
}
